import { render } from "./TradingViewChart.vue?vue&type=template&id=01964daa&scoped=true"
import script from "./TradingViewChart.vue?vue&type=script&lang=js"
export * from "./TradingViewChart.vue?vue&type=script&lang=js"

import "./TradingViewChart.vue?vue&type=style&index=0&id=01964daa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01964daa"]])

export default __exports__